import React, { useState, useEffect } from 'react';
const Mp3Icon = (props) => {
    const [id, setId] = useState(`${Math.random()}`);
    useEffect(() => {
        const id = `${Math.random()}`;
        setId(id);
    }, []);
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M4.66667 0H16.6667L22 5.33333V21.3333C22 22.8061 20.8061 24 19.3333 24H4.66667C3.19391 24 2 22.8061 2 21.3333V2.66667C2 1.19391 3.19391 0 4.66667 0Z", fill: `url(#${id})` }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.333 12.8374V10V8H13.333H16.6663L16.6663 10L13.333 10V15.6667V16H13.3147C13.1489 17.5 11.8772 18.6667 10.333 18.6667C8.67615 18.6667 7.33301 17.3235 7.33301 15.6667C7.33301 14.0098 8.67615 12.6667 10.333 12.6667C10.6836 12.6667 11.0202 12.7268 11.333 12.8374Z", fill: "white" }),
        React.createElement("path", { d: "M16.667 4V0L22.0003 5.33333H18.0003C17.2639 5.33333 16.667 4.73638 16.667 4Z", fill: "white", fillOpacity: "0.5" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: id, x1: "12", y1: "0", x2: "12", y2: "24", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#FF9D75" }),
                React.createElement("stop", { offset: "1", stopColor: "#FF7033" })))));
};
export default Mp3Icon;
